export namespace Forms {
    function requiredFormFields() {
        let requiredFields = document.querySelectorAll('[required="required"]');

        if (requiredFields) {
            for (let i = 0; i < requiredFields.length; i++) {
                let label = requiredFields[i].previousElementSibling;
            
                if (label.classList.contains('form-label')) {
                    label.classList.add('form-label--required');
                }
            }
        }
    }

    export const init = () => {
        requiredFormFields();
    }
}